<template>
  <div>
       <HeadDetailsGama v-on:salve="openModal" v-on:openbrokerlink="brokerlink" :buttonsAccredited="true" :btnNewCorretor="true" :btnNew="true" :titleHead="'Detalhes Corretores'"></HeadDetailsGama>
       <br />
        <Tables class="Table-Corre" ref="tableGrids"
            :columns="head"
            :showSearch="false"
             style="font-family:'Segoe UI'"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="getAllBrokerByAccredited"
            >
              <tr  v-for="data in databrower" v-bind:key="data.id">
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.tipo" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.nome" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.cpf" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.creci" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.cidade" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.estado.sigla" />
                  <TableColumn :newState="true" :newStatusNumber="data.status == 0 ? 1 : 0" :descriptionNewStatus="['Ativo', 'Inativo'][data.status]"  />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="2" :value="data.dataCadastroFormatada" />
                  <TableColumn :IsActionsButtons="true"   :newEditGama="true" slot-scope="" v-on:Change="onChange(data)" v-on:Delete="deleteBrokerAccredited(data)" v-on:Edit="edit(data)" :status="[0,1][data.status]" />
              </tr>

        </Tables>
      <Toaddbroker ref="Toaddbroker" v-on:getAllBrokerByAccredited="getAllBrokerByAccredited"  :id="id"></Toaddbroker>
      <brokerlink ref="brokerlink" v-on:onLoad="getAllBrokerByAccredited" :id="id" ></brokerlink>

  </div>

</template>

<script>
import Tablebrokers from './tablebrokers'
export default Tablebrokers

</script>

<style scoped>

.Table-Corre{
  width: 100%;
  height: 50%;
}

.icon{
  color: #4b4a4a;
}

 @media screen and (max-width: 1600px) {

.Table-Info{
  width: 108%;
  height: 50%;
}

}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/accredited/components/tablebrokers/tablebrokers.vue